/* Edge fade on the collection page's horizontal rails: the quick links strip
   and the server-rendered product strip below the grid. */
(function () {
  'use strict';

  // Horizontal twin of createEdgeFade in pdp-redesign.js (which drives the PDP
  // thumbnail rail and the rug size list). Flags which edges still have hidden
  // content; catalog.css and collection-redesign.css turn the flags into a mask
  // gradient. Pure CSS can't detect scrollability, so this is the only way to
  // fade *only* where something is actually hidden. Lives in its own file
  // because pdp-redesign.js is loaded on product templates only.
  function createEdgeFade(el) {
    return function () {
      var max = el.scrollWidth - el.clientWidth;
      el.classList.toggle('is-scrollable', max > 1);
      el.classList.toggle('at-start', el.scrollLeft <= 1);
      el.classList.toggle('at-end', el.scrollLeft >= max - 1);
    };
  }

  function initRail(rail) {
    // The section:load handler below can re-scan a rail this pass already
    // bound; without a flag that rail would carry two scroll listeners.
    if (rail.dataset.edgeFadeBound === 'true') return;
    rail.dataset.edgeFadeBound = 'true';

    var update = createEdgeFade(rail);
    rail.addEventListener('scroll', update, { passive: true });

    // Prefer the inner box: the quick links rail is width:100% and never
    // changes size when its contents do, so observing it would miss those.
    // The product strip has no inner box — its cards are direct children and
    // fixed-width in CSS — so there the rail itself is the right target, and
    // it does resize with the viewport.
    var target = rail.querySelector('.yv-gallery-box') || rail;
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(target);
    } else {
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(update, 150);
      });
    }

    // Item widths are fixed in CSS, so scrollWidth doesn't wait on the lazy
    // images — one pass now is enough to set the initial state.
    update();
  }

  function init(scope) {
    var rails = (scope || document).querySelectorAll(
      '.collection-quick-links .yv-gallery-outer, .yv-cps__grid'
    );
    Array.prototype.forEach.call(rails, initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: adding or reordering blocks re-renders the section, which
  // drops the listeners and the classes with it.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
